<template>
  <vs-dropdown vs-trigger-click class="cursor-pointer mr-4 mb-4">
    <div
      class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32"
    >
      <span class="mr-2">Ações</span>
      <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
    </div>

    <vs-dropdown-menu>
      <vs-dropdown-item @click="eventInativar" v-if="inativar != null  && $can($actionsDefault.Inativar, subjectPermission)">
        <span>Inativar</span>
      </vs-dropdown-item>

      <vs-dropdown-item @click="eventReativar" v-if="reativar != null  && $can($actionsDefault.Inativar, subjectPermission)">
        <span>Reativar</span>
      </vs-dropdown-item>

      <vs-dropdown-item @click="imprimir">
        <span>Imprimir</span>
      </vs-dropdown-item>

      <vs-dropdown-item v-if="$can($actionsDefault.Exportar, subjectPermission)">
        <span>
          <downloadexcel
            :data="selected"
            :fields="colunas"
            :name="nameFileXls"
            type="xls"
          >
            Exportar
          </downloadexcel>
        </span>
      </vs-dropdown-item>
    </vs-dropdown-menu>
  </vs-dropdown>
</template>

<script>
import downloadexcel from "vue-json-excel";

export default {
  props: {
    inativar: {
      type: String,
    },
    reativar: {
      type: String,
    },
    selected: {
      type: Array,
    },
    colunas: {
      type: Object,
    },
    nameFileXls: {
      type: String,
      default: "Exportado",
    },
    subjectPermission: {
      type: String,
      default: "",
    },
  },
  methods: {
    eventInativar() {
      this.$emit("eventInativar");
    },
    eventReativar() {
      this.$emit("eventReativar");
    },
    imprimir() {
      setTimeout(function () {
        window.print();
      }, 500);
    },
  },
  components: {
    downloadexcel,
  },
};
</script>

<style>
</style>